export function ReceiptActions({ onSave, onExportJson, onExportCsv, exportStatus }) {
  return (
    <div className="topbar-actions" aria-label="Receipt actions">
      <span className="mode-chip">No fake counts</span>
      <button onClick={onSave}>Save Local</button>
      <button onClick={onExportJson}>Export JSON</button>
      <button onClick={onExportCsv}>Export CSV</button>
      <span className="export-status" aria-live="polite">{exportStatus}</span>
    </div>
  );
}
